import { Button } from '@/new/components/shadcn/button';
import { DocChronologyEmptyStateIllustration } from '@/new/pages/matters/:matterId/subsets/:subsetId/chronologies/doc/components/doc-chronology-empty-state-illustration';

interface ProceduralTimelineEmptyStateProps {
  canEdit: boolean;
  /** When provided, renders a "click to browse" affordance for the page dropzone. */
  onBrowse?: () => void;
}

export function ProceduralTimelineEmptyState({ canEdit, onBrowse }: ProceduralTimelineEmptyStateProps) {
  // View-only users can't upload or add events, so avoid copy that invites it.
  if (!canEdit) {
    return (
      <div className="mt-32 flex flex-col items-center">
        <DocChronologyEmptyStateIllustration />

        <p className="font-serif text-2xl font-medium">No procedural events yet</p>

        <p className="mt-2 mb-8 max-w-xl text-center text-balance text-gray-500">
          No procedural events have been added to this matter yet. They will appear here once someone with edit access
          uploads a timetable or adds them.
        </p>
      </div>
    );
  }

  return (
    <div className="mt-32 flex flex-col items-center">
      <DocChronologyEmptyStateIllustration />

      <p className="font-serif text-2xl font-medium">Build your procedural timeline</p>

      <p
        className={
          onBrowse
            ? 'mt-2 max-w-xl text-center text-balance text-gray-500'
            : 'mt-2 mb-8 max-w-xl text-center text-balance text-gray-500'
        }
      >
        Upload a court order, directions, or timetable and Wexler will automatically extract procedural events for your
        review. Events can also be added manually.
      </p>

      {onBrowse && (
        <p className="mt-4 mb-8 max-w-xl text-center text-balance text-gray-500">
          Drag and drop a document here, or{' '}
          <Button variant="ghost" onClick={onBrowse} className="p-0 text-blue-500 hover:text-blue-600">
            click to browse
          </Button>
          .
        </p>
      )}
    </div>
  );
}
